import { sendRequest } from '@widget/tool';

const actions = {
    queryProvinceCityAreaList({ commit, dispatch, state }) {
        return sendRequest({
            method: 'GET',
            url: `/market/address/queryProvinceCityAreaList?appId=1000003401&batchNo=OB00000313&timedate=${new Date().getTime()}`,
            params: {},
            headers: {},
            showNetToast: false,
            showBusinessToast: false,
            showLoading: false,
            needCp: false
        })
            .then(response => {
                commit('syncAddressList', response);
            })
            .catch(error => {
                console.error('fetchAddressList', error);
            });
    },
    queryStreetListByParentId({ commit, dispatch, state }, params) {
        return sendRequest({
            method: 'GET',
            url: `/market/address/queryStreetListByParentId?appId=1000003401&batchNo=${params.awardBatchNo}&parentId=${params.code}&timedate=${new Date().getTime()}`,
            params: {},
            headers: {},
            showNetToast: false,
            showBusinessToast: false,
            showLoading: true,
            needCp: false
        });
    }
};
const mutations = {
    setObject(state, { key, val }) {
        if (state.hasOwnProperty(key)) {
            state[key] = val;
        }
    },
    syncAddressList(state, response) {
        const { ret, data, msg } = response;
        if (ret === 0) {
            state.addressList = data;
        }
    }
};
const state = {
    activityType: 42,
    addressList: []
};
const getters = {
    getHomeData(state, getters, rootState, rootGetters) {
        return state['homeData'];
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
